import { Reducer } from "redux";

import { ServiceStatusMasterActionDispatchTypes } from "../constants/Master";
import { ServiceStatusMasterResponse } from "../models/Api/Master";
import { ServiceStatusMasterDispatchTypes } from "../models/DispatchTypes/Master";
import { setLocalStorageData } from "utils";

export const initialState: ServiceStatusMasterResponse = {
  loading: false,
  response: [],
};

const ServiceStatusMasterReducer: Reducer<
  ServiceStatusMasterResponse,
  ServiceStatusMasterDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case ServiceStatusMasterActionDispatchTypes.SERVICE_STATUS_MASTER_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ServiceStatusMasterActionDispatchTypes.SERVICE_STATUS_MASTER_SUCCESS: {
      setLocalStorageData(
        ServiceStatusMasterActionDispatchTypes.SERVICE_STATUS_MASTER_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case ServiceStatusMasterActionDispatchTypes.SERVICE_STATUS_MASTER_RESET: {
      return initialState;
    }
    case ServiceStatusMasterActionDispatchTypes.SERVICE_STATUS_MASTER_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default ServiceStatusMasterReducer;
